import * as dotenv from 'dotenv'
dotenv.config()

const service = {
  NAME: process.env.REACT_APP_SERVICE_NAME || 'cms',
}

const adminService = {
  URL: process.env.REACT_APP_ADMIN_URL || '',
}

const authService = {
  URL: process.env.REACT_APP_TS_AUTHENTICATION_URL,
  AUTH_PROJECT: process.env.REACT_APP_AUTH_PROJECT,
}

const restfulService = {
  URL: process.env.REACT_APP_TS_RESTFUL_API_URL,
}

const uploadService = {
  URL: process.env.REACT_APP_TS_UPLOAD,
}

const livenessVerificationService = {
  URL: process.env.REACT_APP_LIVENESS_VERIFICATION_URL,
}

const evchargerService = {
  URL: process.env.REACT_APP_TS_EV_CHARGER,
}

const evPaymentSubscriptionService = {
  URL:
    process.env.REACT_APP_TS_EV_PAYMENT_SUBSCRIPTION ||
    `${process.env.REACT_APP_TS_RESTFUL_API_URL || ''}/evcharger-payment-subscription`,
}

const solarB2gService = {
  URL:
    process.env.REACT_APP_TS_SOLAR_B2G ||
    `${process.env.REACT_APP_TS_RESTFUL_API_URL || ''}/cms/solar-b2g`,
}

const bookingService = {
  URL: process.env.REACT_APP_TS_BOOKING || '',
}

const reserveService = {
  URL:
    process.env.NODE_ENV === 'production'
      ? 'https://reserve.haupcar.com'
      : 'https://reserve.staging.k8s.haupcar.com',
}

const allNewWebreserveService = {
  URL: process.env.REACT_APP_ALL_NEW_WEBRESERVE_URL || '',
}

const mapService = {
  URL: process.env.REACT_APP_MAP_API_URL || '',
}

const googleMaps = {
  API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
}

const firebaseConfig = {
  API_KEY: process.env.REACT_APP_FIREBASE_API || '',
  AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  APP_ID: process.env.REACT_APP_FIREBASE_APP_ID || '',
  MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
}

const secret = {
  key: process.env.REACT_APP_SECRET || '',
}

const feature = {
  PRO_FLOW_DEPLOYMENT_DATE:
    process.env.REACT_APP_PRO_FLOW_DEPLOYMENT_DATE || '2026-07-22T16:00:00+07:00',
}

const config = {
  service,
  feature,
  authService,
  restfulService,
  uploadService,
  livenessVerificationService,
  evchargerService,
  mapService,
  evPaymentSubscriptionService,
  solarB2gService,
  googleMaps,
  secret,
  adminService,
  bookingService,
  reserveService,
  allNewWebreserveService,
  firebaseConfig,
}

export default config
